module.exports = __webpack_public_path__ + "img/album3.9c3dce95.jpg";